<div class="card-container">
  @if (communityItem.rideType && isOffRoad) {
    <img class="ride-type-icon" [ngSrc]="rideTypeIcon" [alt]="communityItem.rideType" i18n-alt />
  }
  <a
    id="showActivityOnMap"
    class="image"
    href="javascript:void(0);"
    aria-label="View On Map"
    tabindex="0"
    rdcAnalytics="Open Item Map View"
    [rdcAnalyticsData]="communityItem.linkedType"
    (click)="onViewMapClick()"
    i18n-aria-label
  >
    @if (isEmptyCollection) {
      <div class="image empty-image">
        <svg-icon
          src="/assets/icons/map-icons/shared/collection.svg"
          alt="Cover Image"
          svgClass="collection-icon"
          loading="lazy"
          i18n-alt
        />
      </div>
    } @else {
      @if (thumbnailUrl) {
        <img alt="Cover Image" loading="lazy" [ngSrc]="thumbnailUrl" i18n-alt />
      }
      @if (!thumbnailUrl) {
        <svg-icon
          src="/assets/icons/event-map.svg"
          alt="No Cover Image"
          svgClass="collection-icon"
          loading="lazy"
          i18n-alt
        />
      }
    }
    @if (showViewOnMap) {
      <div class="view-on-map-overlay" i18n>View On Map</div>
    }
  </a>
  <div class="details-wrapper">
    <div class="detail" [class.extra-padding]="rsvpStatus === 'Saved' && !showRideEventVisibility">
      @if (rsvpStatus === 'Saved' && !showRideEventVisibility) {
        <a id="saved" class="saved" rdcAnalytics="Navigate To Saved Community" [routerLink]="['/community', 'saved']">
          <svg-icon src="/assets/icons/bookmark-filled.svg" alt="saved" i18n-alt />
        </a>
      }
      <a
        id="showActivitySummary"
        class="details"
        href="javascript:void(0);"
        tabindex="0"
        rdcAnalytics="Open Item Summary"
        [rdcAnalyticsData]="communityItem.linkedType"
        (click)="onDetailsClick()"
      >
        <div class="details-top" [class.bookmark-icon-visible]="rsvpStatus === 'Saved' && !showRideEventVisibility">
          @if (!rsvpStatus || (rsvpStatus === 'Hosting' && !showRideEventVisibility)) {
            <div class="gray">
              @switch (communityItem.linkedType) {
                @case ('PlannedRide') {
                  <svg-icon
                    src="/assets/icons/map-icons/shared/planned-ride.svg"
                    alt="Route"
                    svgClass="type-icon"
                    i18n-alt
                  />
                }
                @case ('TrackedRide') {
                  <svg-icon
                    src="/assets/icons/map-icons/shared/tracked-ride.svg"
                    alt="Ride"
                    svgClass="type-icon"
                    i18n-alt
                  />
                }
                @case ('Collection') {
                  <svg-icon
                    src="/assets/icons/map-icons/shared/collection.svg"
                    alt="Collection"
                    svgClass="type-icon"
                    i18n-alt
                  />
                }
                @case ('Geofence') {
                  <svg-icon
                    src="/assets/icons/map-icons/shared/geofence.svg"
                    alt="Area"
                    svgClass="type-icon"
                    i18n-alt
                  />
                }
                @case ('Waypoint') {
                  <svg-icon
                    alt="Saved Place"
                    svgClass="icon-img type-icon"
                    [src]="waypointTag?.iconAssetUrl || '/assets/icons/map-icons/shared/waypoint.svg'"
                    i18n-alt
                  />
                }
                @case ('Event') {
                  <svg-icon src="/assets/icons/map-icons/shared/event.svg" alt="Event" svgClass="type-icon" i18n-alt />
                }
              }
            </div>
          }

          @if (rsvpStatus && communityItem.linkedType === 'Event') {
            <div class="flex-1">
              @if (showRideEventVisibility && communityItem.content?.event?.isPublic) {
                <div class="stats">
                  <svg-icon src="/assets/icons/website.svg" alt="event" i18n-alt />
                  <span i18n>Public</span>
                </div>
              }
              @if (showRideEventVisibility && !communityItem.content?.event?.isPublic) {
                <div class="stats">
                  <svg-icon src="/assets/icons/email.svg" alt="event" i18n-alt />
                  <span i18n>Private</span>
                </div>
              }
              @if (rsvpStatus === 'Hosting' && !showRideEventVisibility) {
                <span class="stats" i18n>Hosting</span>
              }
              @if (rsvpStatus === 'Saved' && !showRideEventVisibility) {
                <span class="stats" i18n>Saved</span>
              }
            </div>
          }

          @if (!rsvpStatus && (sharedByDate || sharedByName)) {
            <div class="flex-1">
              <div>
                {{ communityItem.sharedByName }}
                @switch (communityItem.linkedType) {
                  @case ('PlannedRide') {
                    <span i18n>shared a Route</span>
                  }
                  @case ('TrackedRide') {
                    <span i18n>shared a Ride</span>
                  }
                  @case ('Collection') {
                    <span i18n>shared a Collection</span>
                  }
                  @case ('Geofence') {
                    <span i18n>shared an Area</span>
                  }
                  @case ('Waypoint') {
                    <span i18n>shared a Place</span>
                  }
                  @case ('Event') {
                    <span i18n>shared an Event</span>
                  }
                }
              </div>

              <div class="helper-secondary-text">
                {{ sharedByDate }}
              </div>
            </div>
          }
        </div>
      </a>
      @if (true) {
        <div class="helper-align-right like-button">
          @if (communityItem.content?.event?.isPublic !== false) {
            <rdx-like-button class="icon-only" iconColor="black" [iconOnly]="true" [communityItem]="communityItem" />
          }
        </div>
      }
    </div>
    <a
      id="showActivitySummary"
      href="javascript:void(0);"
      tabindex="0"
      rdcAnalytics="Open Item Summary"
      [rdcAnalyticsData]="communityItem.linkedType"
      (click)="onDetailsClick()"
    >
      <div class="details-bottom">
        <div class="heading">
          <div class="helper-bold helper-truncate" [title]="communityItem.name">{{ communityItem.name }}</div>
          @if (communityItem.linkedType !== 'Event' && communityItem.communityFeedback.ratingAverage > 0) {
            <div class="helper-align-right">
              <rdx-rating-display [rating]="communityItem.communityFeedback.ratingAverage" />
            </div>
          }
        </div>

        <div class="description helper-truncate">{{ communityItem.description }}</div>

        <div class="item-details">
          @if (eventDate) {
            <div class="stats">
              <svg-icon src="/assets/icons/event.svg" alt="event date" i18n-alt />
              <span class="large">{{ eventDate }}</span>
            </div>
          }

          @if (communityItem.linkedType === 'Collection' && itemCount) {
            <div class="stats">
              <svg-icon src="/assets/icons/collection-inverted.svg" alt="items in collection" i18n-alt />
              <span class="large">{{ itemCount | number }}</span> <span i18n>items</span>
            </div>
          }

          @if (communityItem.linkedType === 'Event' && communityItem.content.event.distanceInMeters) {
            <div class="stats">
              <svg-icon src="/assets/icons/distance-v2.svg" alt="Length of Rides" i18n-alt />
              <span class="large">
                {{ communityItem.content.event.distanceInMeters | toDistance: 'MiKm' | async }}
                {{ communityItem.content.event.distanceInMeters | toDistanceUnits: 'MiKm' | async }}
              </span>
            </div>
          }

          @if (distance) {
            <div class="stats">
              <svg-icon src="/assets/icons/distance-v2.svg" alt="Length of Tracked Ride" i18n-alt />
              <pii-distance-display id="distance" fontSize="large" [distanceInMeters]="distance" />
            </div>
          }

          @if (duration) {
            <div class="stats">
              <svg-icon src="/assets/icons/time.svg" alt="Duration of Tracked Ride" i18n-alt />
              <pii-duration-display id="duration" minimumUnit="min" fontSize="large" [durationInSeconds]="duration" />
            </div>
          }
        </div></div
    ></a>
  </div>
</div>
